import {useEffect, useState} from "react";
import {obtenerDataLocal} from "../Funciones/obtenerDataLocal";
import {obtenerFechaLocal} from "../Funciones/obtenerFechaLocal";
import {guardarDataLocal} from "../Funciones/guardarDataLocal";
import {guardarFechaLocal} from "../Funciones/guardarFechaLocal";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";

export const useObtenerDataActualizada = ({clave}) => {
    const [data, setData] = useState([]);


    const ingresarData = ({data, fecha}) => {
        setData(data)
        guardarDataLocal({clave: clave, data: data})
        guardarFechaLocal({clave: clave, fecha: fecha})
    }


    const verificarSiActualizado = ({fecha}) => {


        if (fecha <= 0) {
            return false;
        }

        let fechaLocal = obtenerFechaLocal({clave: clave, fecha: fecha})

        // console.log('fechaLocal', fechaLocal)
        // console.log('fechaServer', fecha)

        if (fechaLocal >= fecha) {
            return true;
        } else {
            return false;
        }

    }


    const actualizarDataLocal = async ({fecha, wheres = [], query}) => {

        //   console.log(verificarSiActualizado({fecha: fecha}))

        if (!verificarSiActualizado({fecha: fecha})) {


            let dox = {}

            if (query){
                dox = await obtenerColeccionQuery(query)
            }else{
                dox = await obtenerColWheres({col: clave, wheres: wheres})
            }


            if (dox.data.length > 0) {
                ingresarData({data: dox.data, fecha: fecha})
            }

        }


    }

    useEffect(() => {
        let arr = obtenerDataLocal({clave: clave})
        // console.log(arr)
        setData(arr)
    }, [clave]);
    return {
        data,
        verificarSiActualizado,
        ingresarData,
        actualizarDataLocal
    }

}